const options = {
    autoHeight: true,
    grabCursor: true,
    keyboard: true,
    navigation: {
        prevEl: '.js-slider-location-teaser-prev',
        nextEl: '.js-slider-location-teaser-next',
        disabledClass: 'disabled',
    },
    spaceBetween: 20,
    slidesPerView: 'auto',
    breakpoints: {
        768: {
            slidesPerView: 'auto',
            spaceBetween: 30,
            autoHeight: false,
        },
        991: {
            slidesPerView: 3,
            spaceBetween: 30,
            autoHeight: false,
        },
    },
};

const sliderLocationTeaser = {
    init() {
        const elements = document.querySelectorAll('.js-slider-location-teaser');

        if (!elements.length) return;

        elements.forEach((element) => {
            const {autoplay, loop, speed} = element.dataset;
            if (autoplay === '1') {
                options.autoplay = {delay: 200, disableOnInteraction: false};
                options.speed = speed > 0 ? speed : 2000;
            }

            if (loop === '1') {
                options.loop = true;
            }

            const Slider = slider.default;
            this.sliderLocationTeaser = new Slider(element, options);
        });
    },
};

export default sliderLocationTeaser;
